import polyline from '@mapbox/polyline';
import {GeoJSONSourceSpecification} from 'mapbox-gl';
import {TripData} from '../api/trips-api';
import {getTripStops} from './trips';

export function tripsGeoJson(trips: TripData[]) {
  return {
    type: 'geojson',
    lineMetrics: true,
    promoteId: 'tripKey',
    data: {
      type: 'FeatureCollection',
      features: trips.map((trip) => ({
        type: 'Feature',
        geometry: polyline.toGeoJSON(trip.encoded_polyline),
        properties: {
          tripKey: trip.key,
        },
      })),
      id: 'trips',
    },
  };
}

export function tripStopsGeoJson(
  stops: Awaited<ReturnType<typeof getTripStops>>
) {
  return {
    type: 'geojson',
    lineMetrics: true,
    data: {
      type: 'FeatureCollection',
      features: stops.map((stop) => ({
        geometry: {
          coordinates: stop.coordinates,
          type: 'Point',
        },
        properties: {
          ...stop,
          name: stop.label,
          type: 'stop',
        },
        type: 'Feature',
      })),
      id: 'stops',
    },
    promoteId: 'label',
  } as GeoJSONSourceSpecification;
}
